import { ReactNode } from "react";
import { BlogPageLayout } from "@/components/landing/BlogPageLayout";
import { SEO } from "@/components/SEO";
import { BreadcrumbNav } from "./BreadcrumbNav";
import type { BreadcrumbItem } from "./SchemaMarkup";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface ContentPageLayoutProps {
  title: string;
  description: string;
  canonical: string;
  breadcrumbs: BreadcrumbItem[];
  children: ReactNode;
  ctaHeading?: string;
  ctaDescription?: string;
}

export function ContentPageLayout({
  title,
  description,
  canonical,
  breadcrumbs,
  children,
  ctaHeading = "Ready to respond faster?",
  ctaDescription = "Sorvaine turns tenders into structured, submission-ready proposals. See how it works for your team.",
}: ContentPageLayoutProps) {
  return (
    <BlogPageLayout>
      <SEO title={title} description={description} canonical={canonical} />
      <main className="pt-28 pb-20 max-w-[780px] mx-auto px-6">
        <BreadcrumbNav items={breadcrumbs} />
        {children}

        {/* CTA */}
        <section className="mt-20 rounded-xl border border-gray-200 bg-gray-50 p-8 md:p-12 text-center">
          <h2 className="text-2xl font-semibold tracking-tight text-gray-900">{ctaHeading}</h2>
          <p className="mt-3 text-gray-500 max-w-lg mx-auto">{ctaDescription}</p>
          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to="/book-demo">
              <button className="inline-flex items-center justify-center px-8 h-11 rounded-md bg-primary hover:bg-primary/90 text-white text-sm font-semibold transition-all duration-200 hover:-translate-y-[1px] active:scale-[0.97] shadow-[0_0_16px_hsl(var(--primary)/0.12)]">
                Book a Demo
                <ArrowRight className="ml-2 w-4 h-4" />
              </button>
            </Link>
            <Link to="/rfp-response-software">
              <button className="inline-flex items-center justify-center px-8 h-11 rounded-md border border-gray-200 hover:border-gray-300 text-gray-600 hover:text-gray-900 text-sm font-semibold transition-all duration-200 active:scale-[0.97]">
                Learn More
              </button>
            </Link>
          </div>
        </section>
      </main>
    </BlogPageLayout>
  );
}
